import { render } from "./navbar.vue?vue&type=template&id=987798b2"
import script from "./navbar.vue?vue&type=script&lang=js"
export * from "./navbar.vue?vue&type=script&lang=js"

import "./navbar.vue?vue&type=style&index=0&id=987798b2&lang=css"
script.render = render

export default script